var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { Component } from 'vue-property-decorator';
import _ from 'lodash';
import SalesReportService from '../../api/SalesReportService';
import { EReportCustomerFrom } from '../../enum/EReportCustomerFrom';
import TableList from '../../components/common/TableList.vue';
import Header from './components/SalesDetailHeader.vue';
var List = (function (_super) {
    __extends(List, _super);
    function List() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.service = SalesReportService.getInstance();
        _this.fetchAction = _this.service.getSaleDetailReportList;
        _this.tableHeight = document.documentElement.clientHeight - 260;
        _this.sortColumns = [
            'order_detail_money',
            'order_code',
            'purchase_order_order_code',
            'refund_order_code',
            'order_sup_status_name',
            'is_reconciliation_name',
            'order_ctime',
            'order_atime',
            'supplier_goods_name',
            'goods_type_name',
            'agent_order_code',
            'purchasing_agent',
        ];
        _this.templateType = 2;
        _this.filterColumns = [];
        _this.eReportCustomerFrom = EReportCustomerFrom;
        _this.filter = {
            from: '',
            order_from: 1,
            time_type: 1,
            shop_id: [],
            depot_ids: [],
            search_goods_type: 1,
            goods_type_id: [],
            keyword: '',
            searchKey: 1,
            merge_display: false,
            group_by_order: false,
            s_time: new Date(Date.now() - 7 * 24 * 3600 * 1000),
            e_time: new Date(),
        };
        _this.summaryDetail = {};
        _this.total = 0;
        return _this;
    }
    List.prototype.created = function () {
        var arr = [];
        if (!this.openedCodeData.isOpenMultOrg)
            arr.push('organ_name');
        if (!this.Root_PageAuth.ShowCostAmount)
            arr.push('cost_money');
        if (!this.Root_PageAuth.ShowGrossProfit)
            arr.push('gross_profit');
        if (!this.Root_PageAuth.ShowGrossMargin)
            arr.push('gross_margin');
        this.filterColumns = arr;
        this.initFilter(this.filter);
    };
    List.prototype.fetchCallBack = function (data) {
        this.total = data.total;
        this.summaryDetail = {
            order_detail_money_count: data.order_detail_money_count,
            order_detail_no_tax_money_count: data.order_detail_no_tax_money_count,
            order_detail_tax_money_count: data.order_detail_tax_money_count,
            order_detail_settlement_money_count: data.order_detail_settlement_money_count,
            refund_order_detail_money_count: data.refund_order_detail_money_count,
            refund_order_detail_no_tax_money_count: data.refund_order_detail_no_tax_money_count,
            refund_order_detail_tax_money_count: data.refund_order_detail_tax_money_count,
            order_detail_amount_count: data.order_detail_amount_count,
            order_detail_goods_money_count: data.order_detail_goods_money_count,
            order_detail_reduction_money_count: data.order_detail_reduction_money_count,
            cost_money_count: data.cost_money_count,
            gross_profit_count: data.gross_profit_count,
            goods_nums_count: data.goods_nums_count,
            order_money_count: data.order_money_count,
        };
    };
    List.prototype.initFilter = function (filter) {
        if (_.isDate(filter.s_time)) {
            filter.s_time = filter.s_time.format('yyyy-MM-dd');
        }
        console.log('filter', filter.s_time);
        if (_.isDate(filter.e_time)) {
            filter.e_time = filter.e_time.format('yyyy-MM-dd');
        }
        this.filter = filter;
        this.filter.merge_display = this.filter.merge_display ? 1 : 0;
        this.filter.group_by_order = this.filter.group_by_order ? 1 : 0;
        this.filter.shop_id = (this.filter.shop_id || []).join(',');
        this.filter.depot_ids = (this.filter.depot_ids || []).join(',');
        this.filter.goods_type_id =
            this.filter.search_goods_type == '1' ? (this.filter.goods_type_id || []).join(',') : '';
    };
    List.prototype.search = function (filter) {
        var _this = this;
        this.initFilter(filter);
        var templateTypeObj = {
            '': 2,
            1: filter.merge_display ? 4 : 3,
            2: 5,
            3: 6,
        };
        this.templateType = templateTypeObj[filter.from];
        if (filter.group_by_order) {
            this.templateType = 124;
        }
        this.$nextTick(function () {
            var TableList = _this.$refs.TableList;
            TableList.getPageConfig(TableList.fetch);
        });
    };
    List.prototype.getSummaries = function (param) {
        var _this = this;
        var sums = [];
        var setSummary = function (value, key) {
            var index = param.columns.findIndex(function (item) { return item.label === value; });
            if (index !== -1)
                sums[index] = _this.summaryDetail[key];
        };
        if (this.filter.group_by_order) {
            setSummary('货品数量', 'goods_nums_count');
            setSummary('含税总金额', 'order_money_count');
        }
        else if (this.filter.from == this.eReportCustomerFrom['供应链'] && this.filter.merge_display) {
            setSummary('入库含税金额', 'order_detail_money_count');
            setSummary('入库未税金额', 'order_detail_no_tax_money_count');
            setSummary('入库税额', 'order_detail_tax_money_count');
            setSummary('退货含税金额', 'refund_order_detail_money_count');
            setSummary('退货未税金额', 'refund_order_detail_no_tax_money_count');
            setSummary('退货税额', 'refund_order_detail_tax_money_count');
            setSummary('结算金额', 'order_detail_settlement_money_count');
            setSummary('数量', 'order_detail_amount_count');
        }
        else {
            setSummary('实付金额（含税）', 'order_detail_money_count');
            setSummary('未税金额', 'order_detail_no_tax_money_count');
            setSummary('税额', 'order_detail_tax_money_count');
            setSummary('数量', 'order_detail_amount_count');
            setSummary('应付金额', 'order_detail_goods_money_count');
            setSummary('成本金额', 'cost_money_count');
            setSummary('毛利额', 'gross_profit_count');
        }
        if (!sums.length)
            return null;
        sums[0] = '合计';
        return sums;
    };
    List = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                user: 'user',
                openedCodeData: 'openedCodeData',
            })),
            components: {
                'list-header': Header,
                TableList: TableList,
            },
        })
    ], List);
    return List;
}(Vue));
export default List;
